import ErrorBoundary from './ErrorBoundary.component';

export default ErrorBoundary;
